import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { WebpartContainer } from '../containers'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import * as typesWebpart from '@webparts/store/types'
import * as typesAccount from '@account/store/types'
import { FullMasterTemplate } from '@/modules/@appbase/templates'
import NotiPopup from '@gnb/components/NotiPopup/NotiPopup.vue'

import GnbLeftView from '@gnb/views/GnbLeft/GnbLeftView.vue'
import PopupNotioce from '@home/components/PopupNotice/PopupNotice.vue'
import FixedWebpartContainer from '@home/containers/FixedWebpartContainer/FixedWebpartContainer.vue'
import WebpartPage from '@webparts/components/webpart-page/WebpartPage.vue'
import webpartApi from '@webparts/api'
import * as appbaseTypes from '@appbase/store/types'
import { WebpartDataType } from '@webparts/types/enums'

import ReportEmailModal from '@/modules/home/components/KyoboBook/ReportEmail/ReportEmailModal.vue'
import PurchaseHistoryModal from '@/modules/home/components/KyoboBook/PurchaseHistory/PurchaseHistoryModal.vue'
import CleanDeskModal from '@/modules/home/components/KyoboBook/CleanDesk/CleanDeskModal.vue'

@Component({
    components: { 
        NotiPopup,
        GnbLeftView, 
        WebpartContainer, 
        FullMasterTemplate, 
        FixedWebpartContainer, 
        WebpartPage,     
        PopupNotioce
    },
    computed: {
        ...mapGetters({
            user: typesAccount.USER,
            current: typesAccount.CURRENT,
        }),
    },
    methods: {
        ...mapActions({
            loadCommonInfo: typesWebpart.WEBPART_COMMONDATA
        }), 

        ...mapMutations({
            setTeams: appbaseTypes.TEAMS,
        })
    }
})
export default class HomeView extends Vue {
    setTeams!: (value: boolean) => void
    loadCommonInfo!: (types: WebpartDataType[]) => Promise<any>;
    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: G E T T E R S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    user!: account.User;
    current!: account.TCurrent

    isEnablePopupNotice: boolean = false

    pageId: number = 1
   
    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: L I F E S T Y L E : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //
    mounted() {
        //팝업 알림 대상 
        //App 설정으로 팝업 사용유무 확인 후 component init
        const popupConfig = this.current.appConfig.filter(config => {
            //      key:"UsePopupNotice"
            return config.key.toLowerCase() == "usepopupnotice"
        })

        if (popupConfig.length > 0) {
            if (popupConfig[0].value.toLowerCase() == "true") {
                this.isEnablePopupNotice = true
            }
        }
        //this.load()
    }

    async getPageList() {
        await webpartApi.page.get(this.current.user.comCode).then(r => {            
            this.pageId = r[0].pageId
            this.loadCommonInfo(this.user.isMailUser ? [
                WebpartDataType.UnreadMail,
                WebpartDataType.MonthlyEvent,
                WebpartDataType.DailyEvent
            ] : []);
        })
    }

    created() {
        // this.setTeams(true)
        // const body = document.querySelector('body')
        // if (body) {
        //   body.className = 'bg-body-basic'
        // }
        this.getPageList();
    }

    beforeDestroy() {
        const body = document.querySelector('body')
        if (body) {
            body.className = ''
        }
    }

    openPurchaseHistory(){
        const modal: appbase.IModalOpenable = this.$refs['modal'] as any
            const options: appbase.TModalInfo<any> = {
                component: PurchaseHistoryModal,
                props: {},
                events: {
                    cancel: () => {
                        modal.closeModal()
                    },
                },
            }
            modal.openModal(options)
    }
}
